import styles from './index.module.css';
import { Typography, Box } from "@material-ui/core";
import { useSelector } from 'react-redux';
import { IAppState } from '../../../../store';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

export interface IServiceReminders {
  upcoming: number
  overdue: number
}

const ServiceReminders = ({ data }: { data: IServiceReminders }) => {
  const history = useHistory();
  const userState = useSelector((state: IAppState) => state.authReducer.user)
  const consumerState = useSelector((state: IAppState) => state.consumerWebsiteReducer)
  const { locale, currency } = consumerState.consumerWebsite.organisation
  const { t } = useTranslation()

  const totalReminders = data ? data.upcoming + data.overdue : 0

  return (
    <Box className={styles.enhancedCard}>
      <Box className={styles.cardContentEnhanced}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" style={{ fontWeight: 600, color: "#1e293b", fontSize: "18px" }}>
            {t("root:serviceReminders")}
          </Typography>
          <Box className={styles.metricIcon} style={{ background: "linear-gradient(135deg, #FF6B6B, #FF8E8E)" }}>
            🔧
          </Box>
        </Box>

        <Box>
          <Box display="flex" justifyContent="space-between" alignItems="center" style={{ margin: "20px 0" }}>
            <Box style={{ flex: 1, marginRight: "16px" }}>
              <Box
                style={{
                  padding: "16px",
                  backgroundColor: "#f0f9ff",
                  borderRadius: "12px",
                  border: "2px solid #0ea5e9",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <Box
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    height: "100%",
                    width: `${(data.upcoming / totalReminders) * 100}%`,
                    background: "linear-gradient(90deg, #0ea5e9, #38bdf8)",
                    opacity: 0.1,
                    pointerEvents: "none"
                  }}
                />
                <Typography
                  variant="body2"
                  style={{ color: "#0369a1", fontSize: "12px", fontWeight: 600, marginBottom: "4px" }}
                >
                  {t("root:upcoming")}
                </Typography>
                <Typography
                  variant="h4"
                  style={{
                    color: "#0369a1",
                    fontWeight: 700,
                    fontSize: "32px",
                    cursor: "pointer"
                  }}
                  onClick={() => history.push("/account/vehicles", {
                    showUpcomingServiceVehicles: true
                  })}
                >
                  {data.upcoming}
                </Typography>
              </Box>
            </Box>

            <Box style={{ flex: 1 }}>
              <Box
                style={{
                  padding: "16px",
                  backgroundColor: "#fef2f2",
                  borderRadius: "12px",
                  border: "2px solid #ef4444",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <Box
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    height: "100%",
                    width: `${(data.overdue / totalReminders) * 100}%`,
                    background: "linear-gradient(90deg, #ef4444, #f87171)",
                    opacity: 0.1,
                    pointerEvents: "none"
                  }}
                />
                <Typography
                  variant="body2"
                  style={{ color: "#dc2626", fontSize: "12px", fontWeight: 600, marginBottom: "4px" }}
                >
                  {t("root:overdue")}
                </Typography>
                <Typography
                  variant="h4"
                  style={{
                    color: "#dc2626",
                    fontWeight: 700,
                    fontSize: "32px",
                    cursor: "pointer"
                  }}
                  onClick={() => history.push("/account/vehicles", {
                    showOverdueServiceVehicles: true
                  })}
                >
                  {data.overdue}
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box style={{ textAlign: "center", marginTop: "16px" }}>
            <Typography variant="body2" style={{ color: "#64748b", fontSize: "12px" }}>
              {t("root:totalServiceReminders")}
            </Typography>
            <Typography variant="h6" style={{ color: "#1e293b", fontWeight: 600, fontSize: "18px" }}>
              {totalReminders}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ServiceReminders